import React, { useState } from "react";
import { team } from "../mockData";

const Team = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const visibleMembers = team.slice(currentIndex, currentIndex + 3);

  const handleNext = () => {
    if (currentIndex + 3 < team.length) {
      setCurrentIndex(currentIndex + 3);
    }
  };

  const handlePrev = () => {
    if (currentIndex - 3 >= 0) {
      setCurrentIndex(currentIndex - 3);
    }
  };

  return (
    <div>
      {/* Header */}
      <div className="bg-gray-800 py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
            PROFESSIONAL TEAM
          </h1>
        </div>
      </div>

      {/* Team Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">

          {/* Visible Team Members */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
            {visibleMembers.map((member) => (
              <div
                key={member.id}
                className="shadow-lg border border-gray-200 rounded-lg overflow-hidden"
              >
                {/* Image (NO ZOOM, NO HOVER) */}
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-72 object-cover"
                />

                {/* Static Info — Always Visible */}
                <div className="bg-black text-white p-4 bg-opacity-80">
                  <h3 className="text-lg font-bold">{member.name}</h3>
                  <p className="text-sm text-yellow-400">{member.role}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Buttons */}
          <div className="flex justify-center gap-6 mt-10">
            <button
              onClick={handlePrev}
              disabled={currentIndex === 0}
              className="px-6 py-3 bg-gray-300 hover:bg-gray-400 rounded-lg font-bold disabled:opacity-40"
            >
              ◀ 
            </button>

            <button
              onClick={handleNext}
              disabled={currentIndex + 3 >= team.length}
              className="px-6 py-3 bg-yellow-500 hover:bg-yellow-600 text-white rounded-lg font-bold disabled:opacity-40"
            >
               ▶
            </button>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Team;
